/**
 * Created by user on 2020/3/30.
 */

import { ResponseRequest } from 'request';
import request from '@bluelovers/request-promise';

export { request }
export { ResponseRequest }

export default request
